/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Portals_Readiness_MissingInputs */

const cs_portals_readiness_missing = /** @type {(inputs: Portals_Readiness_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chybí ${i?.count} povinných polí`)
};

const en_portals_readiness_missing = /** @type {(inputs: Portals_Readiness_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} mandatory fields missing`)
};

/**
* | output |
* | --- |
* | "{count} mandatory fields missing" |
*
* @param {Portals_Readiness_MissingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_readiness_missing = /** @type {((inputs: Portals_Readiness_MissingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Readiness_MissingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_readiness_missing(inputs)
	return cs_portals_readiness_missing(inputs)
});